(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-product-page"]) return;
  try {
    
  if (!customElements.get('am-pdp-gallery')) {
    customElements.define('am-pdp-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.am-pdp__track');
        this.thumbs = [...this.querySelectorAll('.am-pdp__thumb')];
        this.dots = [...this.querySelectorAll('.am-pdp__dot')];
        if (!this.track) return;
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(+t.dataset.index)));
        let raf;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.mark(Math.round(this.track.scrollLeft / this.track.clientWidth)));
        }, { passive: true });
      }
      go(i) {
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
        this.mark(i);
      }
      mark(i) {
        this.thumbs.forEach((t, n) => (n === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
        this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      }
    });
  }
  if (!customElements.get('am-pdp-bar')) {
    customElements.define('am-pdp-bar', class extends HTMLElement {
      connectedCallback() {
        const cta = this.closest('.am-pdp')?.querySelector('[data-am-cta]');
        if (!cta || !('IntersectionObserver' in window)) return;
        const link = this.querySelector('a');
        new IntersectionObserver(([e]) => {
          // 2026-10-03 mobile pass: show the bar whenever the main Amazon button is off screen (above or below).
          const past = !e.isIntersecting;
          this.hidden = !past;
          link.tabIndex = past ? 0 : -1;
          document.body.classList.toggle('am-pdp-bar-on', past);
        }).observe(cta);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
